/* istanbul ignore file */ import { getAwaMetaTags } from '@shared/utils/seoUtils';
export const appendHeaderTags = (state)=>{
    const awaMetaTags = getAwaMetaTags(state);
    awaMetaTags.forEach((awaMetaTag)=>{
        if (awaMetaTag) {
            document.head.appendChild(awaMetaTag);
        }
    });
};
